import _jsx from '@babel/runtime/helpers/jsx';
import React, { forwardRef, useMemo, useState, useEffect } from 'react';
import classNames from 'classnames';
import { useId } from '@andes/context';
const namespace = 'andes-radio';
const RadioButton = /*#__PURE__*/function () {
  const RadioButton = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      'aria-label': _willdeprecate$ariaLabel,
      checked = false,
      disabled = false,
      error = false,
      hideLabel = false,
      id,
      inline = false,
      labelPosition = 'right',
      label,
      modifier,
      name,
      onChange,
      srLabel,
      suffix,
      text: _willdeprecate$text,
      value
    } = _ref;
    const componentId = useId(id);
    const computedLabel = label || _willdeprecate$text;
    const computedSrLabel = srLabel || _willdeprecate$ariaLabel;
    const onMouseUp = e => {
      e.target.blur();
    };
    const handleOnChange = event => {
      event.target.value = value;
      if (typeof onChange === 'function') onChange(event);
    };
    const radioClasses = classNames(namespace, {
      ["".concat(namespace, "--error")]: modifier === 'error' || error,
      ["".concat(namespace, "--inline")]: inline,
      ["".concat(namespace, "--disabled")]: disabled,
      ["".concat(namespace, "--inverted")]: labelPosition === 'left',
      ["".concat(namespace, "--suffix")]: suffix
    });
    return /*#__PURE__*/React.createElement("div", {
      className: radioClasses,
      ref: ref
    }, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "-element")
    }, void 0, /*#__PURE__*/_jsx("input", {
      type: "radio",
      className: "".concat(namespace, "__input"),
      id: componentId,
      name: name,
      value: value,
      checked: checked,
      onChange: handleOnChange,
      onMouseUp: onMouseUp,
      disabled: disabled,
      "aria-label": computedSrLabel
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__background")
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__outer-circle")
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__inner-circle")
    }))), computedLabel && !computedSrLabel && !hideLabel && /*#__PURE__*/_jsx("label", {
      className: "".concat(namespace, "__label"),
      htmlFor: componentId
    }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, computedLabel)), suffix);
  });
  RadioButton.displayName = 'RadioButton';
  return RadioButton;
}();
var RadioButton$1 = RadioButton;
const RadioGroup = /*#__PURE__*/function () {
  const RadioGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      'aria-labelledby': _willdeprecate$ariaLabelledby,
      children,
      defaultValue,
      disabled = false,
      inline = false,
      inverted: _willdeprecate$inverted,
      labelPosition = 'right',
      name,
      onChange,
      selectedValue,
      srLabel,
      value
    } = _ref;
    const isUncontrolled = useMemo(() => typeof value === 'undefined', []);
    const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue);
    const computedLabelPosition = _willdeprecate$inverted ? 'left' : labelPosition;
    useEffect(() => {
      if (selectedValue && selectedValue !== uncontrolledValue) {
        setUncontrolledValue(selectedValue);
      }
    }, [selectedValue, uncontrolledValue]);
    useEffect(() => {
      if (!isUncontrolled) {
        setUncontrolledValue(value);
      }
    }, [value, isUncontrolled]);
    const onChangeHandler = event => {
      if (isUncontrolled) setUncontrolledValue(event.target.value);
      if (typeof onChange === 'function') onChange(event);
    };
    const getValue = () => isUncontrolled ? uncontrolledValue : value;
    const radioButtons = React.Children.map(children, radioButton => {
      const isChecked = getValue() === radioButton.props.value;
      return /*#__PURE__*/_jsx(RadioButton$1, {
        checked: isChecked,
        disabled: disabled || radioButton.props.disabled,
        error: radioButton.props.error,
        id: radioButton.props.id,
        inline: inline,
        labelPosition: computedLabelPosition,
        label: radioButton.props.label,
        modifier: radioButton.props.modifier,
        name: name,
        onChange: onChangeHandler,
        srLabel: radioButton.props.srLabel,
        suffix: radioButton.props.suffix,
        text: radioButton.props.text,
        value: radioButton.props.value
      }, radioButton.props.value);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "andes-radioGroup",
      role: "radiogroup",
      "aria-label": srLabel,
      "aria-labelledby": _willdeprecate$ariaLabelledby,
      ref: ref
    }, radioButtons);
  });
  RadioGroup.displayName = 'RadioGroup';
  return RadioGroup;
}();
var RadioGroup$1 = RadioGroup;
export { RadioButton$1 as RadioButton, RadioGroup$1 as RadioGroup, RadioButton$1 as default };
